import {
  RENT_VEHICLE_LIST,
  BOOKED_RENT_VEHICLE_LIST,
  RENTALS_ORDERS_DETAILS,
  LOADING,
  NOT_FOUND
} from "../action/type";

const initialState = {
  list: [{}],
  loading:false,
  not_found:false
};

const rentVehicle = function (state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return { ...state, list: action.payload ,loading:true,not_found:false};
    case NOT_FOUND:
      return { ...state, list: action.payload ,loading:false,not_found:true};
    case RENT_VEHICLE_LIST:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    case BOOKED_RENT_VEHICLE_LIST:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    case RENTALS_ORDERS_DETAILS:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    default:
      return state;
  }
};

export default rentVehicle;
